<!-- eslint-disable -->
<template lang="pug">
    .notification
        .notification-background
        .notification-box
            .notification-wrapper
                .notification-header(v-html="$i18n.t('common.common_notificationPopup')")
                .notification-body
                    .notification-body_wrapper
                        p.notification-message(v-html="message")
                .notification-footer
                    .notification-footer-wrapper
                        cs-checkbox(v-model="checked") {{ $i18n.t('common.common_notificationChecked') }}
                        cs-button(@click="handleCloseModal") {{ $i18n.t('map.map_conversation_close') }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import CsCheckbox from "../../elements/CsCheckbox.vue";
    import CsButton from "../../elements/CsButton.vue";

    export default {
        components: {CsButton, CsCheckbox},
        data () {
            return {
                checked: false,
            }
        },
        methods: {
            handleCloseModal () {
                this.$emit('close', this.checked)
            }
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user
            }),
            message() {
                    return this.$i18n.t('common.common_messageNotificationForTeachers');
            },
        }
    }
</script>

<style lang="scss" scoped>
    .notification {
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        position: fixed;
        z-index: $z-index-modal;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .notification-background {
        width: 100vw;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba($x-color-black, $opacity-default-modal-background);
    }

    .notification-wrapper {
        background-color: $x-color-white;
        padding: 30px;
        border-radius: $border-radius-20;
        @include media($md) {
            padding: 30px;
        }
    }

    .notification-box {
        position: relative;
        width: 100%;
        max-height: calc(100% - 40px);
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        max-width: 320px;
        @include media($md) {
            max-width: 600px;
        }
    }

    .notification-header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        display: flex;
        justify-content: center;
        text-align: center;
    }
    .notification-footer-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>
